/*
Nuts
*/

import hardwareHeaders from '@/modules/standardItems/schemas/hardware/headers'

export default [
  ...hardwareHeaders
]
